import {aisConfig} from "@/config";

/* Subscription is owned by AIS. `service.ais-integration-th` mints a WAP AOC link and we hand
   the browser over to it; AIS then run the confirmation on the subscriber's own device.
   Nothing is charged here, and nothing about the outcome comes back through the browser — AIS
   call the service back server to server on the cURL baked into the link's token, which is
   also where the msisdn arrives.

   `GET /api/ais/wap/link` answers `{ url }`. Shortcode, signing password, RSA key, gateway and
   callback URL are all service side config; the one thing we pass is `transaction_id`. The WAP
   token has no room to carry it, so the service stashes it against the spsID it bakes into the
   callback URL and reclaims it when AIS call back — that is what attributes the subscription.
   The token embeds a timestamp AIS validate, so the link is minted per click and never cached. */
export async function requestAisWapLink(transactionId, signal) {
    const query = transactionId ? `?transaction_id=${encodeURIComponent(transactionId)}` : '';

    const response = await fetch(`${aisConfig.host}${aisConfig.wapLinkPath}${query}`, {
        method: 'GET',
        headers: {'Accept': 'application/json'},
        signal
    });

    if (!response.ok) throw new Error(`WAP link request failed with ${response.status}`);

    const {url} = await response.json();
    if (!url) throw new Error('WAP link missing from the response');

    return url;
}
